import * as React from "react";
import { dateFormatter2, parseAdjust } from "../../../HelperMethods";
import { SchedulerGroup } from "@progress/kendo-react-scheduler";
import { RecurrencePattern, SchedulingStatus } from "../../Shared/AppConstants";

export const getScheduleData = (initialData) => {
  const data =
    initialData.length > 0
      ? initialData.map((data) => {
        let dataItem = JSON.parse(JSON.stringify(data));
        return {
          end: parseAdjust(dataItem.end),
          id: dataItem.id,
          isAllDay:
            dataItem.isAllDay === undefined ? null : dataItem.isAllDay,
          start:
            parseAdjust(dataItem.start) === undefined
              ? null
              : parseAdjust(dataItem.start),
          title: dataItem.title === undefined ? null : dataItem.title,
          typeGroupId: dataItem.typeGroupId === undefined ? null : dataItem.typeGroupId,
          shiftId: dataItem.shiftId === undefined ? null : dataItem.shiftId,
          recurrenceRule: dataItem.recurrenceRule === undefined ? null : dataItem.recurrenceRule,
          recurrenceExceptions: dataItem.recurrenceException === undefined || dataItem.recurrenceException === null ? null : dataItem.recurrenceException.map(date => 
            new Date(date)
          ),
          no_of_pos: dataItem.noOfPos === undefined ? null : dataItem.noOfPos,
          no_of_pos_filled: dataItem.noOfPosFilled === undefined ? null : dataItem.noOfPosFilled,
          shiftName: dataItem.shiftName === undefined ? null : dataItem.shiftName,
          available: dataItem.available === undefined ? null : dataItem.available,
          allocated: dataItem.allocated === undefined ? null : dataItem.allocated,
          generatedId: dataItem.generatedId === undefined ? null : dataItem.generatedId,
          publishedId: dataItem.publishedId === undefined ? null : dataItem.publishedId,
          assignedId: dataItem.assignedId === undefined ? null : dataItem.assignedId,
          availability_id: dataItem.availability_id === undefined ? null : dataItem.availability_id,
          positionId: dataItem.positionId === undefined ? null : dataItem.positionId,
          color: dataItem.color === undefined ? null : dataItem.color,
          group: dataItem.group === undefined ? null : dataItem.group,
          shiftType: dataItem.shiftType === undefined ? null : dataItem.shiftType,
          shiftStartTime: dataItem.shiftStartTime === undefined ? null : dataItem.shiftStartTime,
          shiftEndTime: dataItem.shiftEndTime === undefined ? null : dataItem.shiftEndTime,
          candidateId: dataItem.candidateId === undefined ? null : dataItem.candidateId,
          candidateName: dataItem.candidateName === undefined ? null : dataItem.candidateName,
          recurrence: dataItem.recurrence === undefined ? null : dataItem.recurrence,
          shiftTypeId: dataItem.shiftTypeId === undefined ? null : dataItem.shiftTypeId,
          shiftTypeName: dataItem.shiftTypeName === undefined ? null : dataItem.shiftTypeName,
          Reqs: dataItem.Reqs === undefined ? null : getReqsData(dataItem.Reqs),
          shiftGenType: dataItem.shiftGenType === undefined ? null : dataItem.shiftGenType,
          noOfPosData: dataItem.noOfPosData === undefined && dataItem.noOfPosData === null ? null : getPosData(dataItem.noOfPosData),
        };
      })
      : [];

  return data;
};

export const getPosData = (posData) => {
  if (posData != null) {
    posData = JSON.parse(posData);
    const data =
      posData.length > 0
        ? posData.map((dataItem) => {
          return {
            slotDate: dataItem.date === undefined ? null : parseAdjust(dataItem.date),
            noOfPosFilled: dataItem.no_of_pos === undefined ? null : dataItem.no_of_pos,
          }
        }) : [];
    return data;
  }
  return null;
}

export const getReqsData = (reqData) => {
  if (reqData != null && reqData != "") {
    reqData = JSON.parse(reqData);
    const data =
      reqData.length > 0
        ? reqData.map((dataItem) => {
          return {
            slotDate: dataItem.date === undefined ? null : parseAdjust(dataItem.date),
            reqData: dataItem.req_data === undefined ? null : getReqPosData(dataItem.req_data),
          }
        }) : [];
    return data;
  }
  return null;
}

export const getReqPosData = (reqPosData) => {
  if (reqPosData != null) {
    //reqPosData = JSON.parse(reqPosData);
   const data =
      reqPosData.length > 0
        ? reqPosData.map((dataItem) => {
          return {
            reqStartDate: dataItem.req_start_date === undefined ? null : parseAdjust(dataItem.req_start_date),
            noOfPos: dataItem.no_of_pos === undefined ? null : dataItem.no_of_pos,
            reqNumber: dataItem.req_number === undefined ? null : dataItem.req_number,
          }
        }) : [];
    return data;
  }
  return null;
}

export const isNullCheck = (obj) => {
  return (obj != undefined && obj != null) == true ? true : false;
}

export const isNullObjCheck = (obj) => {
  return (obj != undefined && obj != null && obj.length > 0) == true ? true : false;
}

const formatDateToICalendar = (dateString: string, timeString = "000000"): string => {
  const date = new Date(dateString);
  return `${date.getUTCFullYear()}${(date.getUTCMonth() + 1)
    .toString()
    .padStart(2, "0")}${date.getUTCDate().toString().padStart(2, "0")}T${timeString}Z`;
};

export const generateRecurrenceRule = (
  frequency: RecurrencePattern.DAILY | RecurrencePattern.WEEKLY | RecurrencePattern.MONTHLY,
  interval: number,
  selectedDays: string[],
  endDate?: string, // Format: "YYYY-MM-DD"
  dayOfMonth?: any
): string => {
  let rule = `FREQ=${frequency};INTERVAL=${interval}`;
  
  if (frequency === RecurrencePattern.WEEKLY && selectedDays.length > 0) {
    rule += `;BYDAY=${selectedDays.join(",")}`;
  }

  if (frequency === RecurrencePattern.MONTHLY && dayOfMonth) {
    rule += `;BYMONTHDAY=${dayOfMonth}`;
  }

  // Convert end date to RFC 5545 format
  if (endDate) {
    rule += `;UNTIL=${formatDateToICalendar(endDate, "235959")}`;
  }
  
  return rule;
};

export const checkUntilInRecurrence = (rec, endDate) => {
  if (!rec.includes(";UNTIL=")) {
      rec += `;UNTIL=${formatDateToICalendar(endDate, "235959")}`; // Add a default UNTIL date (modify as needed)
  }
  return rec;
}

export const formatDateToICalendarException = (dateString: string, timeString = "183000"): string => {
  const date = new Date(dateString);
  return `${date.getUTCFullYear()}${(date.getUTCMonth() + 1)
    .toString()
    .padStart(2, "0")}${date.getUTCDate().toString().padStart(2, "0")}T${timeString}Z`;
};

export const generateRecurrenceException = (exceptionDates: string[], time = "183000"): string => {
  if (!exceptionDates || exceptionDates.length === 0) return "";

  return exceptionDates.map(date => formatDateToICalendarException(date, time)).join(",");
};

export const group: SchedulerGroup = {
  resources: ["TypeGroup", "ShiftAndCandiates"],
  orientation: 'vertical'
};

export const getResources = (shiftData, switchValue) => {
    if (!switchValue) {
        shiftData = shiftData.filter(x => x.shiftType != "ASSIGNED");
    }

  if (shiftData.length > 0) {
    const events = [];
    shiftData.forEach((shift, index) => {
      if (shift.shiftName != null && shift.shiftName != 'UNAVAILABLE' && events.filter((x) => x.value === shift.shiftId).length === 0) {
        events.push({
          text: shift.shiftName,
          value: shift.shiftId,
          color: shift.color,
          parentId: 1,
          group: shift.group
        });
      }
    });
    if (events.length > 0) {
      return [
        {
          name: "TypeGroup",
          data: [
            { text: "Shifts & Candidates", value: 1 },
          ],
          field: "typeGroupId",
          valueField: "value",
          textField: "text",
          colorField: "color"
        },
        {
          name: "ShiftAndCandiates",
          data: events,
          valueField: "value",
          textField: "text",
          colorField: "color",
          field: "shiftId"
        }
      ];
    }
  }
}

export const convertToUTCFormat = (dateString: string): string =>{
  // Convert the input date string to a Date object
  const date = new Date(dateString);

  // Ensure it's a valid date
  if (isNaN(date.getTime())) {
      throw new Error("Invalid date string format");
  }

  // Convert to ISO format and ensure milliseconds are `.000Z`
  return date.toISOString().replace(/\.\d{3}Z$/, '.000Z');
}

export const getPositionCount = (start, noOfPosData, no_of_pos) => {
    var date = dateFormatter2(start);
    if (noOfPosData != null) {
        var posData = noOfPosData.filter((x) => x.slotDate.getTime() == new Date(date).getTime());

        if (posData.length > 0) {
            var no_of_pos_filled = posData[0].noOfPosFilled;
            return parseInt(no_of_pos) - parseInt(no_of_pos_filled);
        } else {
            return parseInt(no_of_pos);
        }
    } else {
        return parseInt(no_of_pos);
       // return parseInt(no_of_pos) - parseInt(props.dataItem.no_of_pos_filled);
    }
}

export const getPositionCountFilled = (start, noOfPosData, no_of_pos) => {
    var date = dateFormatter2(start);
    if (noOfPosData != null) {
        var posData = noOfPosData.filter((x) => x.slotDate.getTime() == new Date(date).getTime());

        if (posData.length > 0) {
            var no_of_pos_filled = posData[0].noOfPosFilled;
            return parseInt(no_of_pos_filled);
        } else {
            return 0;
        }
    } else {
        return 0;
    }
}

export const getReqNumberByPosition = (start_date, req_data) => {
  var date = dateFormatter2(start_date);
  if (req_data != null) {
    var reqPosData = req_data.filter((x) => x.slotDate.getTime() == new Date(date).getTime());
    if (reqPosData.length > 0) {
      var reqData = reqPosData[0].reqData;
      if (reqData.length > 0) {
        var reqDetails = reqData.filter((x) => new Date(date).getTime() >= new Date(dateFormatter2(x.reqStartDate)).getTime());
        if (reqDetails != null) {
          return reqDetails.map(r => r.reqNumber).join(", ");
        }
      }
    }
  }
  return "";
}

export const getReqNumberByPositionCount = (start_date, req_data) => {
  var date = dateFormatter2(start_date);
  if (req_data != null) {
    var reqPosData = req_data.filter((x) => x.slotDate.getTime() == new Date(date).getTime());
    if (reqPosData.length > 0) {
      var reqData = reqPosData[0].reqData;
      if (reqData.length > 0) {
        var reqDetails = reqData.filter((x) => new Date(date).getTime() >= new Date(dateFormatter2(x.reqStartDate)).getTime());
        if (reqDetails != null) {
          return reqDetails.map(r => r.noOfPos ?? 0).reduce((sum, count) => sum + count, 0);
        }
      }
    }
  }
  return 0;
}

export const  getAvaliableAndAllocatedShift = (props) => {
    return "Allocated : " + getPositionCountFilled(props.dataItem.start, props.dataItem.noOfPosData, props.dataItem.no_of_pos) + "\n Available: " + getAvaliableCount(props) + "\n " + getReqNumberByPosition(props.dataItem.start, props.dataItem.Reqs);
}

export const  getAvaliableCount = (props) => {
  return ((props.dataItem.shiftType == SchedulingStatus.PUBLISHED) || (props.dataItem.shiftType == SchedulingStatus.GENERATED && props.dataItem.shiftGenType != "REQ"))
                         ? getPositionCountUpdated(props.dataItem.start, props.dataItem.Reqs, props.dataItem.noOfPosData, props.dataItem.no_of_pos)
                         : (props.dataItem.shiftType == SchedulingStatus.GENERATED  && props.dataItem.shiftGenType == "REQ" ? getReqNumberByPositionCount(props.dataItem.start, props.dataItem.Reqs) : 0 )
}

export const getPositionCountUpdated = (start, req_data, noOfPosData, no_of_pos) => {
    let allocatedCount = getPositionCountFilled(start, noOfPosData, no_of_pos);
    var date = dateFormatter2(start);
    if (req_data != null) {
      var reqPosData = req_data.filter((x) => x.slotDate.getTime() == new Date(date).getTime());
      if (reqPosData.length > 0) {
        var reqData = reqPosData[0].reqData;
        if (reqData.length > 0) {
          var reqDetails = reqData.filter((x) => new Date(date).getTime() >= new Date(dateFormatter2(x.reqStartDate)).getTime());
          if (reqDetails != null) {
            return (reqDetails.map(r => r.noOfPos ?? 0).reduce((sum, count) => sum + count, 0)-allocatedCount) > 0 ? (reqDetails.map(r => r.noOfPos ?? 0).reduce((sum, count) => sum + count, 0)-allocatedCount) : 0;
          }
        }
      }
    }
    else if (noOfPosData != null) {
      var posData = noOfPosData.filter((x) => x.slotDate.getTime() == new Date(date).getTime());

      if (posData.length > 0) {
          var no_of_pos_filled = posData[0].noOfPosFilled;
          return parseInt(no_of_pos) - parseInt(no_of_pos_filled);
      } else {
          return parseInt(no_of_pos);
      }
    } 
    else {
      return parseInt(no_of_pos);
    }
}